import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';

@Component({
  selector: 'app-courttype-view',
  templateUrl: './courttype-view.component.html',
  styleUrls: ['./courttype-view.component.css']
})
export class CourttypeViewComponent implements OnInit {

  title="Court type list";
  itemsPerPage: number=5;
  currentPage: number=1;
  CourtTypeDetailsList : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  CourtT_Id : number;
 
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() { 
    this.GetCourtTypeDetails(this.itemsPerPage, 1)
  }

 

  //List of Case Proceedings
  GetCourtTypeDetails(itemsPerPage:any,pageNo:any){ 
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetCourtTypeDetails(itemsPerPage,pageNo);
    this.data.subscribe(
      (response: any) => {
        this.totalItems = response.TotalItemsCount;
        this.itemsPerPage = itemsPerPage;
        this.currentPage = pageNo;    
        this.CourtTypeDetailsList = response.CourtTypeModel; 
        console.log('CourtType Deatils');
        console.log(this.CourtTypeDetailsList);    
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  delete(CourtT_Id){
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.userService.DeleteCourtType(CourtT_Id);
        this.data.subscribe(
         (response: any) => {
             this. GetCourtTypeDetails(this.itemsPerPage, 1)          
         },       
      ); 
    } 
    })
    }
    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetCourtTypeDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetCourtTypeDetails(this.itemsPerPage, pageNo);
    }

    onSearch(s, itemsPerPage: number, pageNo: number) {   
      this.isSearch = true;
      let searchText = this.s.SearchText;
      let searchCriteria = this.s.SearchCriteria;
      if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
        swal("Warning!", "Please enter the search criteria and search text.", "warning");
      else {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.SearchCourtType(searchCriteria, searchText, itemsPerPage, pageNo)
          .subscribe(
            (data: any) => {
              if(data.CourtTypeModel.length!=0){              
              this.CourtTypeDetailsList = data.CourtTypeModel;
              this.totalItems = data.TotalItemsCount;
              this.currentPage = pageNo;
              document.getElementById('loader-spinner').style.display = "none";
            }
            else
            {
            document.getElementById('loader-spinner').style.display = "none";         
            }
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              //swal('Search Failed.');
              this.errorHandler.HandlerError(error);
            });
      }
    }
  
  
  
  }
  

  //Delete

  // delete(CaseProcId){
  //   swal({
  //        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
  //     }).then((result) => {
  //       if (result.value) {
  //       this.data = this.userService.DeleteCaseProcById(CaseProcId);
  //       this.data.subscribe(
  //        (response: any) => {
  //            this.GetCaseProceedingDetails();          
  //        },       
  //     ); 
  //   } 
  //   })
  //   }

  //   onSearch(s,itemsPerPage: number, pageNo: number) {     

  //     this.isSearch = true;
    
  //     var searchText = this.s.SearchText;
  //     var searchCriteria = this.s.SearchCriteria;
  //     if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
  //       swal("Warning!", "Please enter the search criteria and search text.", "warning");
  //     else {     

  //       document.getElementById('loader-spinner').style.display = "block";
  //       this.userService.GetCaseProceedingOnSearch(this.Case_Id,searchCriteria,searchText,)
  //         .subscribe(
  //           (data:any) => {                            
  //             this.caseProceedingdetails = data.Result;              
  //             document.getElementById('loader-spinner').style.display = "none";          
             
  //           }, (error:any) => {
  //             document.getElementById('loader-spinner').style.display = "none";
  //             this.errorHandler.HandlerError(error);
  //           });
  //     }
  //   }




// WEBPACK FOOTER //
// ./src/app/master/court-type/courttype-view/courttype-view.component.ts